import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import ImageUploadModal from 'components/common/ImageUploadModal';
import ja from 'date-fns/locale/ja';
import CONST_SUB_GENRE from 'features/SubGenre/constans';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import { Formik } from 'formik';
import moment from 'moment';
import { useRef, useState } from 'react';
import { Alert, Button, Col, Form, Row, Table } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { IMAGE_SIZES } from 'utils/constants';
import * as yup from 'yup';
import service from '../services';

registerLocale('ja', ja);

interface AddModalInterface {
  show: boolean;
  handleCloseModalAdd?: (status: boolean) => void;
  dataTable?: SubGenre[];
  setDataTable?: (dataTable: SubGenre[] | []) => void;
}

function SubGenreFormAdd({ handleCloseModalAdd, dataTable, setDataTable }: AddModalInterface) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const [fairImgJa, setFairImgJa] = useState('');
  const [fairImgEn, setFairImgEn] = useState('');
  const [fairImgVi, setFairImgVi] = useState('');
  const [fairImgKo, setFairImgKo] = useState('');
  const [fairImgZhHant, setFairImgZhHant] = useState('');
  const [fairImgZhHans, setFairImgZhHans] = useState('');
  // Tablet
  const [fairImgTabletJa, setFairImgTabletJa] = useState('');
  const [fairImgTabletEn, setFairImgTabletEn] = useState('');
  const [fairImgTabletVi, setFairImgTabletVi] = useState('');
  const [fairImgTabletKo, setFairImgTabletKo] = useState('');
  const [fairImgTabletZhHant, setFairImgTabletZhHant] = useState('');
  const [fairImgTabletZhHans, setFairImgTabletZhHans] = useState('');

  const [backgroundImg, setBackgroundImg] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date('2099-12-31'));
  const refRadioBtnBackgrounImg = useRef<HTMLInputElement>(null);
  const refRadioBtnBackgrounColor = useRef<HTMLInputElement>(null);
  const [displayNone, setDisplayNone] = useState('');

  const schema = yup.object().shape({
    name: yup.string().required(t('SubGenre.Validator.name')),
  });
  const initialValues: SubGenre = {
    id: 0,
    name: '',
    fair_img: '',
    fair_img_ja: '',
    fair_img_en: '',
    fair_img_vi: '',
    fair_img_ko: '',
    fair_img_zh_hant: '',
    fair_img_zh_hans: '',
    fair_img_tablet_ja: '',
    fair_img_tablet_en: '',
    fair_img_tablet_vi: '',
    fair_img_tablet_ko: '',
    fair_img_tablet_zh_hant: '',
    fair_img_tablet_zh_hans: '',
    fair_flg: true,
    start_date: moment(startDate).format('YYYY-MM-DD'),
    end_date: moment(endDate).format('YYYY-MM-DD'),
    background_color: '',
    background_img: '',
    background_type: CONST_SUB_GENRE.BACKGROUND_TYPE.COLOR,
    display_name: '',
    display_name_ja: '',
    display_name_en: '',
    display_name_vi: '',
    display_name_ko: '',
    display_name_zh_hant: '',
    display_name_zh_hans: '',
    note: '',
    delete_flg: false,
  };

  function handleCloseModelSucess() {
    handleCloseModalAdd && handleCloseModalAdd(true);
  }

  async function handleSubmitForm(values: SubGenre) {
    await service
      .addSubGenre(values)
      .then((res) => {
        if (dataTable) {
          let data = dataTable;
          data.push(res.data);
          setDataTable && setDataTable(data);
        }
      })
      .then(() => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleCloseModelSucess}
              title={t('SubGenre.Validator.success')}
              message={t('SubGenre.Validator.add_success')}
            ></AlertModal>
          ));
      })
      .catch((error) => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              title={t('SubGenre.Validator.error')}
              message={JSON.stringify(error.response.data.data)}
            ></AlertModal>
          ));
      });
  }

  return (
    <Formik validationSchema={schema} onSubmit={handleSubmitForm} initialValues={initialValues}>
      {({ handleSubmit, handleChange, errors, values, setFieldValue }) => {
        return (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Col sm={10} md={10} lg={10} xl={10}>
                <p>
                  ※モバイルオーダーは、 <br /> 　日本語以外の言語を選択し、その言語が未設定の場合、
                  <br /> 　英語が表示されます。
                </p>
              </Col>
              <Col sm={2} md={2} lg={2} xl={2}>
                <Button
                  className="pull-right"
                  onClick={() => {
                    handleSubmit();
                  }}
                  variant="success"
                >
                  {t('SubGenre.Button.keep')}
                </Button>
              </Col>
            </Form.Group>
            <Table bordered className="table-subgenre">
              <tbody>
                <tr>
                  <th style={{ backgroundColor: '#36489a', width: '50%' }} colSpan={3}>
                    {t('SubGenre.Form.sub_genre_name')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="name"
                      onChange={handleChange}
                      placeholder={t('SubGenre.Form.sub_genre_name')}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={3}>
                    {t('SubGenre.Form.fair_setting')}
                  </th>
                  <td className="genre">
                    <Form.Check
                      type="switch"
                      onChange={(event) => {
                        handleChange(event);
                        if (event.target.checked) {
                          setDisplayNone('');
                        } else {
                          setDisplayNone('none');
                        }
                      }}
                      defaultChecked={true}
                      name="fair_flg"
                      className="style-switch"
                    />
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ width: '13%', backgroundColor: '#ff8000' }} rowSpan={3}>
                    {t('SubGenre.Form.applicable_period')}
                  </th>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={2}>
                    {t('SubGenre.Form.start_date')}
                  </th>
                  <td>
                    <DatePicker
                      locale="ja"
                      onChange={(date: Date) => {
                        if (!date) {
                          date = new Date();
                        }
                        values.start_date = moment(date).format('YYYY-MM-DD');
                        setStartDate(date);
                      }}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      selected={new Date(startDate)}
                      className="form-control"
                      name="start_date"
                      dateFormat="yyyy/MM/dd"
                      disabledKeyboardNavigation
                    />
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={2}>
                    {t('SubGenre.Form.end_date')}
                  </th>
                  <td>
                    <DatePicker
                      locale="ja"
                      onChange={(date: Date) => {
                        if (!date) {
                          date = new Date();
                        }
                        values.end_date = moment(date).format('YYYY-MM-DD');
                        setEndDate(date);
                      }}
                      selected={new Date(endDate)}
                      className="form-control"
                      name="end_date"
                      dateFormat="yyyy/MM/dd"
                      disabledKeyboardNavigation
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                    />
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000', width: '13%' }} rowSpan={14}>
                    {t('SubGenre.Form.fair_picture')}
                  </th>
                  <th rowSpan={7} style={{ backgroundColor: '#ff8000', width: '4%' }}>
                    {t('SubGenre.Form.mobile')}
                  </th>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_ja')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgJa && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgJa}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn1"
                          hidden
                          name="fair_img_ja"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgJa && fairImgJa.length > 0 ? process.env.REACT_APP_IMAGE_URL + fairImgJa : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_ja', filename);
                                  setFairImgJa(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn1" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_en')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgEn && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgEn}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn2"
                          hidden
                          name="fair_img_en"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgEn && fairImgEn.length > 0 ? process.env.REACT_APP_IMAGE_URL + fairImgEn : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_en', filename);
                                  setFairImgEn(filename);
                                }}
                              />
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn2" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_zh_hant')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgZhHant && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgZhHant}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn3"
                          hidden
                          name="fair_img_zh_hant"
                          onClick={() => {
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    fairImgZhHant && fairImgZhHant.length > 0
                                      ? process.env.REACT_APP_IMAGE_URL + fairImgZhHant
                                      : ''
                                  }
                                  minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                  minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                  maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                  onReflect={(filename: string, imagepath: string) => {
                                    setFieldValue('fair_img_zh_hant', filename);
                                    setFairImgZhHant(filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />
                        <label htmlFor="actual-btn3" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_zh_hans')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgZhHans && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgZhHans}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn4"
                          hidden
                          name="fair_img_zh_hans"
                          onClick={() => {
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    fairImgZhHans && fairImgZhHans.length > 0
                                      ? process.env.REACT_APP_IMAGE_URL + fairImgZhHans
                                      : ''
                                  }
                                  minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                  minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                  maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                  onReflect={(filename: string) => {
                                    setFieldValue('fair_img_zh_hans', filename);
                                    setFairImgZhHans(filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />
                        <label htmlFor="actual-btn4" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_ko')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgKo && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgKo}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn5"
                          hidden
                          name="fair_img_ko"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgKo && fairImgKo.length > 0 ? process.env.REACT_APP_IMAGE_URL + fairImgKo : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_ko', filename);
                                  setFairImgKo(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn5" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_vi')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgVi && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgVi}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col>
                        <input
                          type="button"
                          id="actual-btn6"
                          hidden
                          name="fair_img_vi"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgVi && fairImgVi.length > 0 ? process.env.REACT_APP_IMAGE_URL + fairImgVi : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_mobile_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_mobile_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_mobile_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_mobile_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_mobile_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_vi', filename);
                                  setFairImgVi(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn6" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>

                {/* #################################################################TABLET######################################################################################## */}
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000', width: '4%' }} rowSpan={7}>
                    {t('SubGenre.Form.tablet')}
                  </th>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_ja')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletJa && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletJa}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn7"
                          hidden
                          name="fair_img_tablet_ja"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgTabletJa && fairImgTabletJa.length > 0
                                    ? process.env.REACT_APP_IMAGE_URL + fairImgTabletJa
                                    : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_tablet_ja', filename);
                                  setFairImgTabletJa(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn7" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_en')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletEn && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletEn}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn8"
                          hidden
                          name="fair_img_tablet_en"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgTabletEn && fairImgTabletEn.length > 0
                                    ? process.env.REACT_APP_IMAGE_URL + fairImgTabletEn
                                    : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_tablet_en', filename);
                                  setFairImgTabletEn(filename);
                                }}
                              />
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn8" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_zh_hant')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletZhHant && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletZhHant}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn9"
                          hidden
                          name="fair_img_tablet_zh_hant"
                          onClick={() => {
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    fairImgTabletZhHant && fairImgTabletZhHant.length > 0
                                      ? process.env.REACT_APP_IMAGE_URL + fairImgTabletZhHant
                                      : ''
                                  }
                                  minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                  minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                  maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                  onReflect={(filename: string, imagepath: string) => {
                                    setFieldValue('fair_img_tablet_zh_hant', filename);
                                    setFairImgTabletZhHant(filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />
                        <label htmlFor="actual-btn9" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_zh_hans')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletZhHans && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletZhHans}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn10"
                          hidden
                          name="fair_img_tablet_zh_hans"
                          onClick={() => {
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    fairImgTabletZhHans && fairImgTabletZhHans.length > 0
                                      ? process.env.REACT_APP_IMAGE_URL + fairImgTabletZhHans
                                      : ''
                                  }
                                  minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                  minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                  maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                  onReflect={(filename: string) => {
                                    setFieldValue('fair_img_tablet_zh_hans', filename);
                                    setFairImgTabletZhHans(filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />
                        <label htmlFor="actual-btn10" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_ko')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletKo && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletKo}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn11"
                          hidden
                          name="fair_img_tablet_ko"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgTabletKo && fairImgTabletKo.length > 0
                                    ? process.env.REACT_APP_IMAGE_URL + fairImgTabletKo
                                    : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_tablet_ko', filename);
                                  setFairImgTabletKo(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn11" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: displayNone }}>
                  <th style={{ backgroundColor: '#ff8000' }} colSpan={1}>
                    {t('SubGenre.Form.fair_img_vi')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={10} md={10} lg={10} xl={10}>
                        {fairImgTabletVi && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + fairImgTabletVi}
                            alt="img"
                            width={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col>
                        <input
                          type="button"
                          id="actual-btn12"
                          hidden
                          name="fair_img_tablet_vi"
                          onClick={() => {
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  fairImgTabletVi && fairImgTabletVi.length > 0
                                    ? process.env.REACT_APP_IMAGE_URL + fairImgTabletVi
                                    : ''
                                }
                                minWidth={IMAGE_SIZES.subgenre_tablet_fair_img.minWidth}
                                minHeight={IMAGE_SIZES.subgenre_tablet_fair_img.minHeight}
                                maxWidth={IMAGE_SIZES.subgenre_tablet_fair_img.maxWidth}
                                maxHeight={IMAGE_SIZES.subgenre_tablet_fair_img.maxHeight}
                                maxFileSize={IMAGE_SIZES.subgenre_tablet_fair_img.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('fair_img_tablet_vi', filename);
                                  setFairImgTabletVi(filename);
                                }}
                              ></ImageUploadModal>
                            ));
                          }}
                        />
                        <label htmlFor="actual-btn12" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>

                {/* ###################################################################ENDTABLET###################################################################################### */}
                <tr style={{ display: 'none' }}>
                  <th style={{ width: '13%' }} rowSpan={3}>
                    {t('SubGenre.Form.background')}
                  </th>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ width: '13%' }} colSpan={2}>
                    {t('SubGenre.Form.color')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          name="background_type"
                          ref={refRadioBtnBackgrounColor}
                          onChange={handleChange}
                          value={CONST_SUB_GENRE.BACKGROUND_TYPE.COLOR}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        <Alert
                          key="danger"
                          variant="light"
                          style={{
                            textAlign: 'center',
                            backgroundColor: values.background_color,
                            height: 45,
                            color: '#ffffff',
                          }}
                        >
                          {values.name}
                        </Alert>
                      </Col>
                      <Col>
                        <Form.Control
                          id="actual-color"
                          type="color"
                          defaultValue="#ffffff"
                          name="background_color"
                          onChange={(event) => {
                            handleChange(event);
                            if (refRadioBtnBackgrounColor.current) {
                              console.log(refRadioBtnBackgrounColor.current.click());
                            }
                          }}
                          style={{ width: 45, height: 45 }}
                        />
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th colSpan={2}>{t('SubGenre.Form.image')}</th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          name="background_type"
                          ref={refRadioBtnBackgrounImg}
                          onChange={handleChange}
                          value={CONST_SUB_GENRE.BACKGROUND_TYPE.IMG}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        {backgroundImg && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + backgroundImg}
                            alt="img"
                            width={IMAGE_SIZES.genre_order_background_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn"
                          hidden
                          name="background_img"
                          onClick={() => {
                            if (refRadioBtnBackgrounImg.current) {
                              refRadioBtnBackgrounImg.current.click();
                            }
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    backgroundImg && backgroundImg.length > 0
                                      ? process.env.REACT_APP_IMAGE_URL + backgroundImg
                                      : ''
                                  }
                                  minWidth={IMAGE_SIZES.genre_order_background_img.minWidth}
                                  minHeight={IMAGE_SIZES.genre_order_background_img.minHeight}
                                  maxWidth={IMAGE_SIZES.genre_order_background_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.genre_order_background_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.genre_order_background_img.maxFileSize}
                                  onReflect={(filename: string, imagepath: string) => {
                                    setFieldValue('background_img', filename);
                                    setBackgroundImg(filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />

                        <label htmlFor="actual-btn" style={{ marginRight: 10 }}>
                          {t('SubGenre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#36489a' }}>
                  <th rowSpan={7}>{t('SubGenre.Form.display_name')}</th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.japanese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={handleChange}
                      name="display_name_ja"
                      placeholder="セレクトランチ"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.english')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={handleChange}
                      name="display_name_en"
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.simplified_chinese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hans"
                      onChange={handleChange}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.chinese_traditional')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hant"
                      onChange={handleChange}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.korean')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={handleChange}
                      name="display_name_ko"
                      placeholder="셀렉트 점심"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('SubGenre.Form.vietnamese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={handleChange}
                      name="display_name_vi"
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('SubGenre.Form.remarks')}
                  </th>
                  <td>
                    <Form.Control as="textarea" onChange={handleChange} name="note" rows={3} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SubGenreFormAdd;
